/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 오늘의 홍보학교 페이지 홍보 효과 탭 요소 컴포넌트
 * 버전 : 1.0
 * 파일명 : PromotionEffect.tsx
 * 작성자 : 강동형 
 * 작성일 : 2025-07-03
 * 수정 : 2025-07-04, 강동형 : API 연결 및 코드 작성
 * ================================================================ */

import { useEffect, useState } from 'react'
import styled from 'styled-components';
import { postTodaysEffectiveSchools } from 'src/api/Main';
import TodaysPromotionList, { BottomSheetTypeExtand } from './TodaysPromotionList';
import { useMainPageDialogStore } from 'src/stores/DialogStore';
import { parseSchoolData } from 'src/utils/Etc';

const PageWrapper = styled.div`
    display : flex;
    flex-direction: column;
    flex: 1;
`

const ListWrapper = styled.div`
    padding: 0px 20px;
`

const PromotionEffect = () => {
    const [top3,setTop3] = useState<BottomSheetTypeExtand[]>([])
    const setField = useMainPageDialogStore((state)=>state.setField)
    const fetchTop3 = async () => {
        try {
            const response = await postTodaysEffectiveSchools();  
            const sorted = response.data.sort((a:any, b:any) => b.total_bonus - a.total_bonus);
            setTop3(sorted);
        } catch (error) {
            console.error('top3 불러오기 실패:', error);
        }
    };
    useEffect(()=>{
        fetchTop3()
    },[])

  const handleClick = (e:any)=>{
    setField('isOpen',true)
    setField('selected',{...e, isAi : true})
  }

    return (
        <PageWrapper>
            <ListWrapper>
                {top3.map((item,index)=>(
                    <div onClick={()=>handleClick(item)}>
                    <TodaysPromotionList results={parseSchoolData(item)} isLast={top3.length-1 === index}/>
                    </div>
                ))}
            </ListWrapper>
        </PageWrapper>
    )
}
export default PromotionEffect